import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import { BrokerService } from "./BrokerService";
import { getBrokerProductByFormType } from "./brokerProductRegistry";
import ApplyBusinessV2 from "../Form/forms/BusinessV2/ApplyBusinessV2";
import ApplyIndividualLite from "../Form/forms/ApplyIndividualLite";

// Broker edit route (/applications/:edit_id/edit). The route param carries only the draft
// id, not its product, so we resolve the draft's `formType` once and render the matching
// apply form in brokerMode. The formType → component mapping is driven by the product
// registry (`editComponent`), so adding a new managed product needs no change here.
// Both forms accept `formId={edit_id}` (ApplyBusinessV2 also reads :edit_id directly;
// ApplyIndividualLite reads :individual_id, so it relies on the formId prop here).
const EDIT_COMPONENTS = {
  ApplyBusinessV2,
  ApplyIndividualLite,
};

const BrokerApplicationEdit = () => {
  const { edit_id } = useParams();
  const [formType, setFormType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    BrokerService.detail(edit_id)
      .then((response) => { if (active) setFormType(response?.data?.formType || null); })
      .catch(() => { if (active) setFormType(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [edit_id]);

  if (loading) {
    return (
      <div className="broker-page d-flex justify-content-center align-items-center" style={{ minHeight: 240 }}>
        <FaSpinner className="broker-spin" />
      </div>
    );
  }

  // Default to ApplyBusinessV2 (the prior behaviour) for unknown/unsupported formTypes.
  const product = getBrokerProductByFormType(formType);
  const Component = EDIT_COMPONENTS[product?.editComponent] || ApplyBusinessV2;
  return <Component brokerMode formId={edit_id} />;
};

export default BrokerApplicationEdit;
